import React from "react";
import styled from "styled-components";
import media from "Styles/media";
const Wrapper = styled.div`
	padding: 0 ${(props) => `${props.theme.size.offset.pc}px`};

	@media ${media.tablet} {
		padding: 0 ${(props) => `${props.theme.size.offset.tablet}px`};
	}
`;
interface ContainerDefaultProps {
	className?: string;
}
const ContainerDefault: React.FC<ContainerDefaultProps> = ({ children, className }) => {
	return <Wrapper className={className}>{children}</Wrapper>;
};

export default ContainerDefault;
